export default __webpack_public_path__ + "static/da_icon-148d58d6405f043ba9e254204d7e7290.png";